import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type Lang = 'en' | 'it' | 'ar' | 'es' | 'fr' | 'de';
const RTL: Lang[] = ['ar'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);
  // Same language set as fe-umrah-express-web's ChangeCurrentLanguageComponent.
  readonly available: Lang[] = ['en', 'it', 'ar', 'es', 'fr', 'de'];
  readonly lang = signal<Lang>((localStorage.getItem('hbh_lang') as Lang) || 'en');

  init(): void {
    this.translate.addLangs(this.available);
    this.translate.setDefaultLang('en');
    this.apply(this.lang());
  }
  set(l: Lang): void { localStorage.setItem('hbh_lang', l); this.lang.set(l); this.apply(l); }
  private apply(l: Lang): void {
    this.translate.use(l);
    const dir = RTL.includes(l) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', l);
  }
}
